import type { ChangeEvent } from 'react'

import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Box } from 'app/components/design-system-components'
import { CheckBoxGeneral } from 'app/components/forms/forms'
import {
  getPreApprovalNotifyTooltipText,
  PRE_APPROVAL_NOTIFY_LABEL,
} from 'app/sm/team_viewing_preference/applications/pre-approval-notify-setting.helpers'
import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'

const TOOLTIP_ID = 'preApprovalNotifyTeamInfo'

export interface PreApprovalNotifySettingProps {
  isVisible: boolean
  isChecked: boolean
  isUserAdmin: boolean
  isAccountPremier: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const PreApprovalNotifySetting = ({
  isVisible,
  isChecked,
  isUserAdmin,
  isAccountPremier,
  onChange,
}: PreApprovalNotifySettingProps): JSX.Element | null => {
  if (!isVisible) {
    return null
  }

  const isDisabled = !isUserAdmin || !isAccountPremier
  const tooltipText = getPreApprovalNotifyTooltipText({
    isAccountPremier,
    isUserAdmin,
  })

  return (
    <>
      <div className="mb15">
        <CheckBoxGeneral
          id={applicationsAttributesIDs.preApprovalNotifyTeam}
          label={PRE_APPROVAL_NOTIFY_LABEL}
          onChange={onChange}
          checked={isChecked}
          eventProcessedByComponent
          disabled={isDisabled}
          showDisabledGrey={isDisabled}
          toolTip={
            (
              <div>
                <i
                  className="icon-help-outline fs16 gray-light-color ibm"
                  data-tooltip-content=""
                  data-tooltip-id={TOOLTIP_ID}
                />
              </div>
            ) as unknown as string // CheckBoxGeneral is a JS base component; proper toolTip typing needs changes there first.
          }
        />
      </div>

      <div>
        <ReactTooltip id={TOOLTIP_ID} className="tool-tip-style">
          <Box maxWidth="260px">{tooltipText}</Box>
        </ReactTooltip>
      </div>
    </>
  )
}

export default PreApprovalNotifySetting
